<template>
  <div class="calendar-legend">
    <div class="flex col-gap-12">
      <div class="calendar-legend__item">
        <div class="legend-indicator legend-indicator--incomes"></div>
        <span>{{ $t('incomesLabel') }}</span>
      </div>
      <div class="calendar-legend__item">
        <div class="legend-indicator legend-indicator--expenses"></div>
        <span>{{ $t('expensesLabel') }}</span>
      </div>
      <div class="calendar-legend__item">
        <div class="legend-indicator legend-indicator--transfers"></div>
        <span>{{ $t('transfersLabel') }}</span>
      </div>
    </div>
    <div class="flex col-gap-12 ml-auto">
      <div class="calendar-legend__item">
        <div class="legend-indicator legend-indicator--plan-incomes"></div>
        <span>{{ $t('incomesPlanLabel') }}</span>
      </div>
      <div class="calendar-legend__item">
        <div class="legend-indicator legend-indicator--plan-expenses"></div>
        <span>{{ $t('expensesPlanLabel') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalendarTableLegend",
  i18n: {
    messages: {
      en: {
        incomesLabel: 'Incomes',
        expensesLabel: 'Expenses',
        transfersLabel: 'Transfers',
        incomesPlanLabel: 'Incomes planned',
        expensesPlanLabel: 'Expenses planned',
      },
      ru: {
        incomesLabel: 'Доходы',
        expensesLabel: 'Расходы',
        transfersLabel: 'Переводы',
        incomesPlanLabel: 'Плановые доходы',
        expensesPlanLabel: 'Плановые расходы',
      }
    }
  }
}
</script>

<style lang="scss">
.calendar-legend {
  @apply flex;
  &__item {
    @apply flex items-center text-sm text-text;
    .legend-indicator {
      @apply rounded-full;
      width: 10px;
      height: 10px;
      margin-right: 5px;

      &--incomes {
        @apply bg-green;
      }

      &--expenses {
        @apply bg-red;
      }

      &--transfers {
        @apply bg-yellow;
      }

      &--plan-incomes {
        @apply bg-white border border-green;
      }

      &--plan-expenses {
        @apply bg-white border border-red;
      }
    }
  }
}
</style>